import { Chip } from "@mui/material";
import { lightGreenColor, yellowColor } from "../../../../theme";

type NeurofeedbackGlobalGradeChipProps = {
    grade: number | null | undefined;
};

const getGradeBackgroundColor = (grade: number) => {
    if (grade < 3) {
        return { color: "error" as const, customBg: undefined };
    }
    if (grade >= 3 && grade < 3.5) {
        return { color: undefined, customBg: yellowColor };
    }
    if (grade >= 3.5 && grade <= 4) {
        return { color: undefined, customBg: lightGreenColor };
    }
    return { color: "success" as const, customBg: undefined };
};

export const NeurofeedbackGlobalGradeChip = ({ grade }: NeurofeedbackGlobalGradeChipProps) => {
    if (grade === null || grade === undefined) {
        return <Chip sx={{ width: 50 }} label="-" color="default" />;
    }

    const gradeColor = getGradeBackgroundColor(grade);
    const chipSx = gradeColor.customBg
        ? { width: 50, backgroundColor: gradeColor.customBg, color: "#fff" }
        : { width: 50 };

    return <Chip sx={chipSx} label={grade} color={gradeColor.color} />;
};
